import { CddEmbeddedFields } from '../../../eddQuestions/pages/direct/field.types';
import { CddVolumesQuestion } from '../../common/CddVolumesQuestion';
import type { CddDomesticWireVolumesFormContentKeys } from '../../common/cddVolumesForm.types';

export const CddDomesticWireVolumesForm = ({
  contentKeys,
}: {
  contentKeys: CddDomesticWireVolumesFormContentKeys;
}) => (
  <div>
    <CddVolumesQuestion
      sectionKey='domesticWireVolumes'
      fieldName={CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_INCOMING}
      contentKey={contentKeys.domesticWiresIncoming}
    />
    <CddVolumesQuestion
      sectionKey='domesticWireVolumes'
      fieldName={CddEmbeddedFields.CDD_DOMESTIC_WIRE_VOLUMES_OUTGOING}
      contentKey={contentKeys.domesticWiresOutgoing}
    />
  </div>
);
